import React from 'react'
import { createNativeStackNavigator } from '@react-navigation/native-stack'
import { NotesScreen, EditNote, SelectNoteRecipient } from '@screens'

export type NotesStackParamList = {
  NotesList: {
    profileId?: string
  }
  EditNote:
    | {
        noteId?: string
        contactId?: string
        isGhost?: boolean
      }
    | undefined
  SelectNoteRecipient: undefined
}

const Stack = createNativeStackNavigator<NotesStackParamList>()

const NotesStackNavigator: React.FC = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
      }}
    >
      <Stack.Screen name="NotesList" component={NotesScreen} />
      <Stack.Screen name="EditNote" component={EditNote} />
      <Stack.Screen name="SelectNoteRecipient" component={SelectNoteRecipient} />
    </Stack.Navigator>
  )
}

export default NotesStackNavigator
